import { CenterAddressType } from '@nkr/enums/center-address-type';
import { ICenterAddress } from '@nkr/models/index';
import { DropdownButton, MenuItem, OverlayTrigger, Popover } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';

interface IProps {
    address: ICenterAddress,
    onAction: (id: number, action: any) => void
}

const ListRow = (props: IProps) => {
    const address = props.address;

    const getOverlay = (note: string) => {
        return (
            <Popover>
                {ReactHtmlParser(note)}
            </Popover>
        );
    }

    return (
        <tr>
            <td>{address.typeName}</td>
            <td>{address.label}</td>
            <td>
                {address.typeId == CenterAddressType.StrongBoxShipTo && <div>First/Last Name: {address.firstName && address.lastName ? address.firstName + ' ' + address.lastName : '- MISSING -'}</div>}
                {address.typeId == CenterAddressType.StrongBoxShipTo && <div>Ship To Phone Number: {address.shipToPhoneNumber ? address.shipToPhoneNumber : '- MISSING -'}</div>}
            </td>
            <td>
                <span>{address.addressLine1}</span>
                {address.addressLine2 != '' && (
                    <span><br /> {address.addressLine2}</span>
                )}
                {address.addressLine3 != '' && (
                    <span><br /> {address.addressLine3}</span>
                )}
            </td>
            <td>{address.city}</td>
            <td>{address.stateAbbreviation}</td>
            <td>{address.postalCode}</td>

            <td>
                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={getOverlay(address.note)}>
                    <span> {address.note.length == 0 ? '' : address.note.substring(0, 15) + '...'}</span>
                </OverlayTrigger>
            </td>

            <td>
                <DropdownButton bsStyle='primary' bsSize='sm' title='Actions' pullRight id={'addresses-action-' + address.id} onSelect={(e) => props.onAction(address.id, e)}>
                    <MenuItem eventKey='EDIT'>Edit</MenuItem>
                    <MenuItem eventKey='DELETE'>Delete</MenuItem>
                </DropdownButton>
            </td>
        </tr>
    );
}

export default ListRow;